export const BASE_SPINDLE_BE_URL = process.env.REACT_APP_SPINDLE_BE_URL;
export const TEST_ENDPOINT_SPINDLE_BE_URL = process.env.REACT_APP_SPINDLE_BE_ENDPOINT_TESTING_URL;
export const URL_DEBUGGING_VALIDATE = `/debugging/validate/endpoint`;

export const BASE_ERROR_CONSTANT = 'Something went wrong. Please contact support@fabric.inc..';
